// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M6.65 4.65C6.65 5.75 5.75 6.65 4.65 6.65C3.55 6.65 2.65 5.75 2.65 4.65C2.65 3.55 3.55 2.65 4.65 2.65C5.75 2.65 6.65 3.55 6.65 4.65Z',
  'M13.35 11.35C13.35 12.45 12.45 13.35 11.35 13.35C10.25 13.35 9.35 12.45 9.35 11.35C9.35 10.25 10.25 9.35 11.35 9.35C12.45 9.35 13.35 10.25 13.35 11.35Z',
  'M8.9 4.65H13.35',
  'M2.65 11.35H7.1',
];
